import { isNone } from '@ember/utils';
import $ from 'jquery';

// Used to measure the exact width of rendered text
export function measureText(text, tagName = 'div', classNames = '', css = {}) {
  if (isNone(text)) {
    return 0;
  }

  // eslint-disable-next-line ember/no-jquery
  const textToMeasure = $(`<${tagName} class="${classNames}">${text}</${tagName}>`).css(css).css({
    display: 'none'
  });
  $('body').append(textToMeasure); // eslint-disable-line ember/no-jquery
  const width = textToMeasure.width();
  textToMeasure.remove();
  return width;
}